import { FormControl, Grid, Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import {
  CommonButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomMenuItem,
  CustomRequiredInputLabel,
  StyledDateContainer,
  CustomSelectforFamily,
  CommonOutlinedButton,
} from "../../common/StyledComponents/StyledFields";
import { useState, useEffect } from "react";
import { ValidationError, object, string } from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { apiRequest } from "../../../infrastructure/backendService";
import { PriestListProps } from "../../../infrastructure/GlobalContextProvider";
import apiPath from "../../../config/apiPaths.json";
import { ClipLoader } from "react-spinners";

const PriestBookingReport = ({ sendDataToParent, getReportData }: any) => {
  interface ErrorMessageTypesSearch {
    poojaDateFrom: string;
    poojaDateTo: string;
    selectPriest: string;
  }
  const formFieldsPriestsBookingReport = {
    poojaDateFrom: dayjs().subtract(7, 'day').format("MM/DD/YYYY"),
    poojaDateTo: dayjs().format("MM/DD/YYYY"),
    selectPriest: "",
  };

  const errors: ErrorMessageTypesSearch = {
    ...formFieldsPriestsBookingReport,
  };

  const validationSchemaForpooja = object().shape({
    selectPriest: string().required("Priest Name is required"),
    // poojaDateFrom: string()
    // .required('Pooja Date From is required'),
    // poojaDateTo: string()
    // .required('Pooja Date To is required'),
  });

  const [errorMessagePriestBooking, setErrorMessagePriestBooking] =
    useState<ErrorMessageTypesSearch>({ ...formFieldsPriestsBookingReport });
  const [formDataPriestsBookingReport, setFormDataPriestsBookingReport] =
    useState(formFieldsPriestsBookingReport);
  const [priestList, setPriestList] = useState<PriestListProps[]>([]);
  const [selectedPriestId, setSelectedPriestId] = useState<string | undefined>(
    ""
  );
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    apiRequest({
      method: "GET",
      // endpoint: apiPath.priestList,
      endpoint: "/devotee-management/userCategories/priestAndEventHallList",
      includeToken: true,
    })
      .then((res) => {
        setPriestList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getPriestBookingReports = () => {
    const reqBody = {
      priestName: selectedPriestId,
      poojaFromDate: formDataPriestsBookingReport.poojaDateFrom,
      poojaToDate: formDataPriestsBookingReport.poojaDateTo,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:
        "/report-dashboard/reports/priest/PRIEST_BOOKING_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, reqBody, formDataPriestsBookingReport);
        const response = res?.data?.map((obj: any) => {
          return {
            "Priest Name": obj.priestFullName,
            Date: obj.poojadate,
            "Start Time": obj.starttime,
            "End Time": obj.endtime,
            Pooja: obj.poojaname,
            "Type of Pooja": obj.incomeaccount,
            "Booked By": obj.priestSelectedbyFullName,
            "Devotee Name": obj.devoteeFullName,
            "Language preferred of Devotee": obj.preflanguage,
          };
        });
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmitPriestBookingreport = async () => {
    try {
      // Validate the form data against the validation schema
      await validationSchemaForpooja.validate(formDataPriestsBookingReport, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessagePriestBooking(errors);
      // Call your API or perform other actions here
      // saveApiCall();
      getPriestBookingReports();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesSearch] = e.message;
          }
        });
      }
      setErrorMessagePriestBooking(errors);
    }
  };

  const handleSearchByDateChange = (field: any, value: any) => {
    if (field === "poojaDateFrom" || field === "poojaDateTo") {
      let formattedDate = dayjs(value, "MM/DD/YYYY");
      setFormDataPriestsBookingReport({
        ...formDataPriestsBookingReport,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM/DD/YYYY")
          : "",
      });
    } else if (field === "selectPriest") {
      const selectedPriestIds = priestList.find(
        (item: PriestListProps) => item.priest_id === value
      );
      setSelectedPriestId(selectedPriestIds?.priest_id);
      setFormDataPriestsBookingReport({
        ...formDataPriestsBookingReport,
        [field]: value,
      });
    }
  };

  const PoojaDateFrom = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataPriestsBookingReport.poojaDateFrom
                    ? dayjs(
                        formDataPriestsBookingReport.poojaDateFrom,
                        "MM-DD-YYYY"
                      )
                    : ""
                }
                onChange={(value) => {
                  handleSearchByDateChange("poojaDateFrom", value);
                  setErrorMessagePriestBooking({
                    ...errorMessagePriestBooking,
                    poojaDateFrom: "",
                  });
                }}
                className={styles.dateFeildforfamily
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const PoojaDateTo = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataPriestsBookingReport.poojaDateTo
                    ? dayjs(
                        formDataPriestsBookingReport.poojaDateTo,
                        "MM-DD-YYYY"
                      )
                    : ""
                }
                onChange={(value) => {
                  handleSearchByDateChange("poojaDateTo", value);
                  setErrorMessagePriestBooking({
                    ...errorMessagePriestBooking,
                    poojaDateTo: "",
                  });
                }}
                className={styles.dateFeildforfamily
                }
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const priestListDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectforFamily
          id="selectPriest"
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Select Priest"
          value={formDataPriestsBookingReport.selectPriest || ""}
          onChange={(e) => {
            handleSearchByDateChange("selectPriest", e.target.value);
            setErrorMessagePriestBooking({
              ...errorMessagePriestBooking,
              selectPriest: "",
            });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessagePriestBooking.selectPriest
              ? styles.errorTextField
              : styles.dateFeildforfamily
          }
        >
          {priestList.map((item: PriestListProps, index: number) => (
            <CustomMenuItem key={index} value={item.priest_id}>
              {item.priestname}
            </CustomMenuItem>
          ))}
        </CustomSelectforFamily>
        {errorMessagePriestBooking.selectPriest ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessagePriestBooking.selectPriest}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const handleClear = () => {
    setFormDataPriestsBookingReport(formFieldsPriestsBookingReport);
  };

  return (
    <div>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Priest Name", true)}
          {priestListDropdown()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Pooja Date From", true)}
          {PoojaDateFrom()}
        </Grid>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Pooja Date To", true)}
          {PoojaDateTo()}
        </Grid>
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitPriestBookingreport}
          disabled={loading}
          id="submit"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Submitting...
              </span>
            </>
          ) : (
            "Submit"
          )}
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
    </div>
  );
};

export default PriestBookingReport;
